import defaultTemplate from "./default";
import japanTemplate from "./japan";
import australiaTemplate from "./australia";

export const templateRegistry = {
  default: defaultTemplate,
  japan: japanTemplate,
  australia: australiaTemplate,
};

export default templateRegistry;
